import React from 'react';
import { DatePicker, Form, Icon, Popover, TimePicker } from 'antd';
import moment from "moment";

const DateFormat = 'DD.MM.YYYY';
const OfferEndDateTime = ({ form, disabled }) => {
  function disabledDate(current) {
    return current && current >= arrivalDatetime
  }
  const { getFieldDecorator, getFieldValue } = form;
  const arrivalDatetime = getFieldValue('arrivalDatetime');

  const popover = (
    <div className="popover-content">
      <p>
        После наступления указанных вами даты и времени предложение будет
        архивировано. Оферта будет отозвана
      </p>
    </div>
  );
  return (
    <div className="offer-card__item">
      <span className="label" style={{ lineHeight: 'normal' }}>
        Дата и время окончания предложения (оферты):
      </span>
      <Form.Item>
        {getFieldDecorator('actionDatetime', {
          rules: [
            {
              required: true,
              message: 'Поле, обязательное для заполнения'
            }
          ]
        })(
          <DatePicker
            style={{ width: 224 }}
            format={DateFormat}
            placeholder="Укажите дату"
            disabled={disabled}
            disabledDate={disabledDate}
          />
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator('actionDatetime')(
          <TimePicker
            style={{ width: 128 }}
            defaultOpenValue={arrivalDatetime && moment(arrivalDatetime)}
            placeholder="Время"
            format={'HH:mm'}
            disabled={disabled}
          />
        )}
      </Form.Item>
      <span className="extra-label">
        <span className="show-map">
          <Popover
            overlayClassName="order-popover"
            placement="topLeft"
            content={popover}
            title="Срок действия предложения"
            trigger="click"
          >
            <Icon type="question-circle" />
          </Popover>
        </span>
      </span>
    </div>
  );
};

export default OfferEndDateTime;
